import { SimpleDialog } from '@core/components/Dialog';
import { useApiUtils } from '@core/util/apiUtils';
import { grupoClienteApi } from 'app/services/api/grupoClienteApi';
import * as Actions from 'app/store/actions';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { ClienteContext } from '../cliente/ClienteContext';
import { clienteModais } from '../cliente/components/modal/clienteModais';
import { GrupoClienteContext } from './GrupoClienteContext';
import ListagemGrupoCliente from './components/formListagem/ListagemGrupoCliente';
import CadastroGrupoCliente from './components/formcadastro/CadastroGrupoCliente';

const GrupoClienteModal = () => {
  const [modal] = useContext(ClienteContext).modal;
  const [formulario] = useContext(GrupoClienteContext).formulario;
  const [, setGruposCliente] = useContext(GrupoClienteContext).gruposCliente;
  const [, setLoading] = useContext(GrupoClienteContext).loading;
  const [, setTotalElements] = useContext(GrupoClienteContext).totalElements;
  const [page, setPage] = useContext(GrupoClienteContext).page;
  const [size, setSize] = useContext(GrupoClienteContext).size;
  const [sort, setSort] = useContext(GrupoClienteContext).sort;

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const initialPage = {
    page,
    q: '',
    size,
    sort,
  };

  const fetchGruposCliente = async (search = initialPage) => {
    setLoading(true);
    try {
      const response = await grupoClienteApi().buscarGrupoCliente(search);
      setPage(response.data.number);
      setSize(response.data.size);
      setSort(response.data.sort?.replace(': ', ','));
      setTotalElements(response.data.totalElements);
      setGruposCliente(response.data.content);
    } catch (err) {
      apiUtils.handleApiError(err);
    }

    setLoading(false);
  };

  return (
    <SimpleDialog open={modal === clienteModais.cadastroGrupoCliente}>
      {formulario === 'listagem' ? (
        <ListagemGrupoCliente fetchGruposCliente={fetchGruposCliente} />
      ) : (
        <CadastroGrupoCliente fetchGruposCliente={fetchGruposCliente} />
      )}
    </SimpleDialog>
  );
};

export default GrupoClienteModal;
